// Safe array utilities to prevent "undefined is not iterable" errors

export function safeArray<T>(value: T[] | undefined | null): T[] {
  if (!value || !Array.isArray(value)) {
    return [];
  }
  return value;
}

export function safeMap<T, R>(
  array: T[] | undefined | null,
  callback: (item: T, index: number) => R
): R[] {
  const safe = safeArray(array);
  return safe.map(callback);
}

export function safeFilter<T>(
  array: T[] | undefined | null,
  predicate: (item: T, index: number) => boolean
): T[] {
  const safe = safeArray(array);
  return safe.filter(predicate);
}

export function safeFind<T>(
  array: T[] | undefined | null,
  predicate: (item: T, index: number) => boolean
): T | undefined {
  const safe = safeArray(array);
  return safe.find(predicate);
}

export function safeLength(array: any[] | undefined | null): number {
  return safeArray(array).length;
}